import type {
  PipelineBoardSort,
  PipelineColumn as PipelineColumnDto,
} from '@/pages/pipelines/common/types';

import { PipelineColumn } from './column';
import { BoardScroller, TerminalDivider } from './styled';

type Props = {
  columns: PipelineColumnDto[];
  expandedStage?: string;
  allExpanded?: boolean;
  isMobile: boolean;
  filteredStages: string[];
  sort?: PipelineBoardSort;
  dragAvailable: boolean;
  dragInteractionDisabled: boolean;
  dragSourceStage?: string | null;
  onExpand: (_stage: string) => void;
  onSelectCard: (_cardId: string) => void;
  onToggleStageFilter?: (_stage: string) => void;
  onToggleSort?: () => void;
  onAddCard?: (_stage: string) => void;
};

export const PipelineBoardColumns = ({
  columns,
  expandedStage,
  allExpanded = false,
  isMobile,
  filteredStages,
  sort,
  dragAvailable,
  dragInteractionDisabled,
  dragSourceStage,
  onExpand,
  onSelectCard,
  onToggleStageFilter,
  onToggleSort,
  onAddCard,
}: Props) => {
  let terminalDividerRendered = false;

  return (
    <BoardScroller data-testid="pipeline-board-scroller">
      {columns.map((column) => {
        const shouldRenderDivider = !isMobile && column.terminal && !terminalDividerRendered;
        if (shouldRenderDivider) terminalDividerRendered = true;

        return (
          <div key={column.stage} style={{ display: 'contents' }}>
            {shouldRenderDivider && <TerminalDivider data-testid="terminal-column-divider" />}
            <PipelineColumn
              column={column}
              expanded={allExpanded || column.stage === expandedStage}
              dragAvailable={dragAvailable}
              dragInteractionDisabled={dragInteractionDisabled}
              stageFiltered={filteredStages.includes(column.stage)}
              sortActive={Boolean(sort?.active)}
              onExpand={onExpand}
              onSelectCard={onSelectCard}
              onToggleStageFilter={onToggleStageFilter}
              onToggleSort={onToggleSort}
              onAddCard={onAddCard}
              dragSourceStage={dragSourceStage}
            />
          </div>
        );
      })}
    </BoardScroller>
  );
};
